"use client";

import { useEffect } from "react";
import { useRouter, useSearchParams } from "next/navigation";

/**
 * Client component that handles password reset redirects from Supabase.
 * Separated from the main page to allow server-side rendering of content.
 */
export default function PasswordResetHandler() {
  const router = useRouter();
  const searchParams = useSearchParams();

  useEffect(() => {
    // Legacy recovery query links are not part of the server-side auth flow.
    // Current Supabase templates use /auth/confirm?token_hash=... instead.
    const type = searchParams.get("type");
    const token = searchParams.get("token");

    if (type === "recovery" && token) {
      const params = new URLSearchParams({
        token_hash: token,
        type: "recovery",
      });
      router.replace(`/auth/confirm?${params.toString()}`);
      return;
    }

    // Legacy implicit recovery links expose access tokens in the URL fragment.
    // Authentication is server-side now, so do not move those tokens into query
    // params where they would be logged, shared, or persisted in history.
    const hash = window.location.hash;
    if (
      hash &&
      hash.includes("access_token") &&
      hash.includes("type=recovery")
    ) {
      router.push("/reset-password?error=invalid_token");
      return;
    }
  }, [searchParams, router]);

  // This component doesn't render anything
  return null;
}
